export const footerData = {
  "Real estate": {
    data1: [
      { propertyName: "Real estate Abia", propertyLink: "/" },
      { propertyName: "Real estate Adamawa", propertyLink: "/" },
      { propertyName: "Real estate Akwa Ibom", propertyLink: "/" },
      { propertyName: "Real estate Anambra", propertyLink: "/" },
      { propertyName: "Real estate Bauchi", propertyLink: "/" },
      { propertyName: "Real estate Bayelsa", propertyLink: "/" },
    ],

    data2: [
      { propertyName: "Real estate Benue", propertyLink: "/" },
      { propertyName: "Real estate Borno", propertyLink: "/" },
      { propertyName: "Real estate Cross River", propertyLink: "/" },
      { propertyName: "Real estate Delta", propertyLink: "/" },
      { propertyName: "Real estate Ebonyi", propertyLink: "/" },
      { propertyName: "Real estate Edo", propertyLink: "/" },
    ],

    data3: [
      { propertyName: "Real estate Ekiti", propertyLink: "/" },
      { propertyName: "Real estate Enugu", propertyLink: "/" },
      { propertyName: "Real estate Gombe", propertyLink: "/" },
      { propertyName: "Real estate imo", propertyLink: "/" },
      { propertyName: "Real estate jigawa", propertyLink: "/" },
      { propertyName: "Real estate Zamfara", propertyLink: "/" },
    ],
  },

  // "New homes": {
  //   data1: [
  //     { propertyName: "Home builders", propertyLink: "/" },
  //     { propertyName: "House and land", propertyLink: "/" },
  //     { propertyName: "Home builders Perth", propertyLink: "/" },
  //     { propertyName: "Home builders Adelaide", propertyLink: "/" },
  //     { propertyName: "House and land packages Sydney", propertyLink: "/" },
  //     { propertyName: "House and land packages Canberra", propertyLink: "/" },
  //   ],

  //   data2: [
  //     { propertyName: "House designs", propertyLink: "/" },
  //     { propertyName: "Land estates", propertyLink: "/" },
  //     { propertyName: "Home builders Sydney", propertyLink: "/" },
  //     {
  //       propertyName: "House and land packages Melbourne",
  //       propertyLink: "/",
  //     },
  //     { propertyName: "House and land packages Brisbane", propertyLink: "/" },
  //   ],

  //   data3: [
  //     { propertyName: "New apartments", propertyLink: "/" },
  //     { propertyName: "Home builders Melbourne", propertyLink: "/" },
  //     { propertyName: "Home builders Brisbane", propertyLink: "/" },
  //     { propertyName: "House and land packages Perth", propertyLink: "/" },
  //     { propertyName: "House and land packages Adelaide", propertyLink: "/" },
  //   ],
  // },

  // "Popular areas": {
  //   data1: [
  //     { propertyName: "Sydney house prices", propertyLink: "/" },
  //     { propertyName: "Brisbane house prices", propertyLink: "/" },
  //     { propertyName: "Canberra house prices", propertyLink: "/" },
  //   ],

  //   data2: [
  //     { propertyName: "Perth house prices", propertyLink: "/" },
  //     { propertyName: "Adelaide house prices", propertyLink: "/" },
  //     { propertyName: "Suburb profiles", propertyLink: "/" },
  //   ],

  //   data3: [
  //     { propertyName: "Melbourne house prices", propertyLink: "/" },
  //     { propertyName: "Hobart house prices", propertyLink: "/" },
  //   ],
  // },

  // "Popular searches": {
  //   data1: [
  //     { propertyName: "Property news", propertyLink: "/" },
  //     { propertyName: "Mortgage calculator", propertyLink: "/" },
  //     { propertyName: "Selling property", propertyLink: "/" },
  //     { propertyName: "Property guides", propertyLink: "/" },
  //     { propertyName: "Rent to buy", propertyLink: "/" },
  //     { propertyName: "Auction results", propertyLink: "/" },
  //   ],

  //   data2: [
  //     { propertyName: "Commercial property news", propertyLink: "/" },
  //     { propertyName: "Capital gains tax Australia", propertyLink: "/" },
  //     { propertyName: "Negative gearing", propertyLink: "/" },
  //     { propertyName: "How much is my house worth", propertyLink: "/" },
  //     {
  //       propertyName: "How much does it cose to build a house",
  //       propertyLink: "/",
  //     },
  //   ],

  //   data3: [
  //     { propertyName: "Stamp duty calculator", propertyLink: "/" },
  //     { propertyName: "Renovation", propertyLink: "/" },
  //     { propertyName: "How much can I borrow", propertyLink: "/" },
  //     { propertyName: "The block", propertyLink: "/" },
  //     { propertyName: "Australia housing market", propertyLink: "/" },
  //   ],
  // },
};
